<!--
 * @Description: 页面主体中的面包屑组件，供程序框架使用
 * @Author: laoliu,wanqian
 * @Date: 2021-04-12 20:43:52
 * @LastEditTime: 2024-03-27 10:40:40
-->
<template>
  <div class="breadcrumb" width="100%">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>
        <span :style="'font-weight:' + (navInfo.text2 ? 'normal' : 'bold')">{{navInfo.text1}}</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item v-if="navInfo.text2">
        <span :style="'font-weight:' + (navInfo.text3 ? 'normal' : 'bold')">{{navInfo.text2}}</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item v-if="navInfo.text3">
        <span :style="'font-weight:' + (navInfo.text4 ? 'normal' : 'bold')">{{navInfo.text3}}</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item v-if="navInfo.text4">
        <span :style="'font-weight:' + (navInfo.text5 ? 'normal' : 'bold')">{{navInfo.text4}}</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item v-if="navInfo.text5">{{navInfo.text5}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: ['navInfo'],

  watch: {
    'navInfo': {
      handler(newValue, _oldValue) {
        let text = '';
        if (newValue.text5) {
          text = newValue.text5;
        } else if (newValue.text4) {
          text = newValue.text4;
        } else if (newValue.text3) {
          text = newValue.text3;
        } else if (newValue.text2) {
          text = newValue.text2;
        } else {
          text = newValue.text1;
        }
        this.$nextTick(() => {
          if (process.env.NODE_ENV == 'sdjk' || process.env.NODE_ENV == 'sdjktest') {
            document.title = '悠心陪护-' + text;
          } else {
            document.title = '星护云-' + text;
          }
        });
      },
      deep: true
    },
  },
}
</script>

<style scoped>
.breadcrumb {
  margin-bottom: 15px;
  padding: 22px 40px;
  text-align: center;
  border-bottom: solid #f2f3f4 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/pageframe/components/Breadcrumb.vue